import React, { useState, FunctionComponent } from 'react';
import Modal from '../Modal/Modal';
import styles from './VideoStoryModal.scss';
import { Trans, useTranslation } from 'react-i18next';
import CopyToClipboard from '@justgiving/copy-to-clipboard';
interface VideoStoryModalProps {
  setShowModal: (off: boolean) => void;
  videoUrl: string;
}

export const VideoStoryModal: FunctionComponent<VideoStoryModalProps> = ({
  videoUrl,
  setShowModal,
}: {
  videoUrl: string;
  setShowModal: (off: boolean) => void;
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  function handleClose() {
    setShowModal(false);
  }

  function copyToClipBoard() {
    setCopiedToClipboard(true);
  }

  return (
    <Modal
      onCloseRequest={handleClose}
      displayCloseButton
      className={styles.modal}
    >
      <div className="container">
        <h3 className="jg-h3">
          {t('videoStory.modal.heading', 'Your video is now ready to watch')}
        </h3>
        <video
          height="400"
          width="100%"
          id="video-player"
          preload="metadata"
          controls
          autoPlay
          poster={
            'https://images.staging.jg-cdn.com/image/d8bd4900-db15-4c44-a9b6-322b809fb3a5.jpg'
          }
        >
          <source src={videoUrl!} type="video/mp4" />
        </video>
        {/* TODO DO the share here */}
        <div>
          <div className={`${styles.description}`}>
            <h4
              className={`jg-h4 jg-h1 jg-space-mtlg jg-space-mbxs jg-text--center ${styles.title}`}
            >
              Share your video story with friends
            </h4>
          </div>
          <div className="jg-space-mbmd">
            <CopyToClipboard
              text={videoUrl!}
              copyMessage={<Trans i18nKey="common.copyLink">Copy link</Trans>}
              copiedMessage={
                <Trans i18nKey="common.linkCopied">Copied to clipboard</Trans>
              }
              copied={copiedToClipboard}
              onCopy={copyToClipBoard}
            />
          </div>
        </div>
        <button className={styles.closeButton} onClick={handleClose}>
          {t('videoStory.modal.close', 'Close')}
        </button>
      </div>
    </Modal>
  );
};
